import Session from 'Faster/model/Session';
import GeoPointJsonTransformer, { GeoPointJSON } from 'Faster/serialization/GeoPointJsonTransformer';

interface SessionJSON {
  id: string;
  userId?: string;
  geoPoint?: object;
  properties?: object;
  createdInBackground: boolean;
  startedAt?: string;
  ntpStartedAt?: string;
  updatedAt?: string;
  ntpUpdatedAt?: string;
  closed: boolean;
  remotelyPersisted: boolean;
}

class SessionJsonTransformer {
  static fromJson(json: SessionJSON | string): Session {
    if (typeof json === 'string') {
      return JSON.parse(json, SessionJsonTransformer.reviver);
    }

    if (typeof json !== 'object' || null === json) {
      return null;
    }

    const session = Object.create(Session.prototype);
    const { geoPoint, startedAt, ntpStartedAt, updatedAt, ntpUpdatedAt } = json;

    return Object.assign(session, json, {
      geoPoint: (geoPoint && GeoPointJsonTransformer.fromJson(geoPoint as GeoPointJSON)) || null,
      startedAt: (startedAt && new Date(startedAt)) || null,
      ntpStartedAt: (ntpStartedAt && new Date(ntpStartedAt)) || null,
      updatedAt: (updatedAt && new Date(updatedAt)) || null,
      ntpUpdatedAt: (ntpUpdatedAt && new Date(ntpUpdatedAt)) || null,
    });
  }

  static toJsonObject(session: Session): object {
    if (typeof session !== 'object' || null === session) {
      return null;
    }

    const scalarObject = Object.assign({}, session, {
      geoPoint: GeoPointJsonTransformer.toJsonObject(session.geoPoint),
      startedAt: (session.startedAt && session.startedAt.toISOString()) || null,
      ntpStartedAt: (session.ntpStartedAt && session.ntpStartedAt.toISOString()) || null,
      updatedAt: (session.updatedAt && session.updatedAt.toISOString()) || null,
      ntpUpdatedAt: (session.ntpUpdatedAt && session.ntpUpdatedAt.toISOString()) || null,
    });

    return scalarObject;
  }

  static toJson(session: Session): string {
    return JSON.stringify(SessionJsonTransformer.toJsonObject(session));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static reviver(key: string, value: any): Session {
    const isRootLevel = key === '';

    return isRootLevel ? SessionJsonTransformer.fromJson(value) : value;
  }
}

export default SessionJsonTransformer;
// eslint-disable-next-line no-undef
export { SessionJSON };
